"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientApolloProvider = void 0;
const React = require("react");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_client_1 = require("apollo-client");
const apollo_link_1 = require("apollo-link");
const apollo_link_ws_1 = require("apollo-link-ws");
const apollo_upload_client_1 = require("apollo-upload-client");
const apollo_utilities_1 = require("apollo-utilities");
const react_apollo_1 = require("react-apollo");
const BaseProvider_1 = require("@gdp/react-app/lib/platforms/BaseProvider");
class ClientApolloProvider extends BaseProvider_1.BaseProvider {
    constructor(preloadedState, httpLinkOptions, wsLinkConfiguration, defaultOptions, reducerConfig, ssrForceFetchDelay, resolvers, initialData) {
        const cache = new apollo_cache_inmemory_1.InMemoryCache(reducerConfig).restore(preloadedState);
        const httpLink = (0, apollo_upload_client_1.createUploadLink)(httpLinkOptions);
        const wsLink = wsLinkConfiguration && new apollo_link_ws_1.WebSocketLink(wsLinkConfiguration);
        const link = wsLink
            ? (0, apollo_link_1.split)(({ query }) => {
                const definition = (0, apollo_utilities_1.getMainDefinition)(query);
                return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
            }, wsLink, httpLink)
            : httpLink;
        super(new apollo_client_1.ApolloClient({
            cache,
            defaultOptions,
            ssrForceFetchDelay,
            link,
            resolvers
        }));
        if (initialData)
            cache.writeData(initialData);
    }
    component(children) {
        return React.createElement(react_apollo_1.ApolloProvider, { client: this.provider }, children);
    }
}
exports.ClientApolloProvider = ClientApolloProvider;
//# sourceMappingURL=ClientApolloProvider.js.map